// Firestore rejects `undefined` field values (unless ignoreUndefinedProperties
// is set, which it is not on either platform). Mutations that spread a converted
// domain entity can carry an `undefined` field through to the write payload — the
// goal converter emits `undefined` for an absent progressDateRangePreset. Strip
// those keys before writing. Shallow on purpose: `null` is preserved (queries rely
// on it, e.g. where('completedAt','==',null)), and Timestamp / serverTimestamp
// sentinels are left untouched rather than recursed into.
export const stripUndefined = <T extends object>(obj: T): T =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined),
  ) as T;
